export default __webpack_public_path__ + "static/media/image-tel-mobile.c1193f1c.png";